import React from "react";
import { connect } from "react-redux";

import Dialog from "../../components/dialog/Dialog";
import DialogClose from "../../components/dialog/DialogClose";
import DialogContent from "../../components/dialog/DialogContent";
import DialogFooter from "../../components/dialog/DialogFooter";
import DisplayTypeSet from "../../types/system/DisplayTypeSet";
import {
    DisplaySettingSection,
} from "../../types/system/DisplayType";
import {
    getWorkingConfig,
    initWorking,
    storeWorking,
    storeWorkingAll,
} from "../../state/system/Display";
import { IAppState } from "../../state/Store";
import Panel from "../panels/Panel";
import {
    FlexBehaviour,
    FlexDirection,
    Side,
    Size,
} from "../../types/system/Layout";
import DialogOK from "../dialog/DialogOK";

import "./DisplaySettings.scss";
import GeneralContainer from "../containers/GeneralContainer";
import DisplaySettingsReports from "./DisplaySettingReports";
import DisplaySettingMain from "./DisplaySettingMain";

interface DisplaySettingsProps {
    open: boolean;

    routeDisplay: string[];
    workingDisplay: DisplayTypeSet;

    displaySettingsClosed: Function;

    initWorking: () => void;
    storeWorking: () => void;
    storeWorkingAll: () => void;
}

interface DisplaySettingsState {}

class DisplaySettings extends React.Component<
    DisplaySettingsProps,
    DisplaySettingsState
> {
    componentDidUpdate(
        prevProps: Readonly<DisplaySettingsProps>,
        prevState: Readonly<DisplaySettingsState>,
        snapshot?: any,
    ): void {
        if (this.props.open && !prevProps.open) {
            this.props.initWorking();
        }
    }

    hasReports() {
        return this.props.workingDisplay?.types.some(
            type => type.section === DisplaySettingSection.Reports,
        );
    }

    render() {
        return (
            <Dialog
                dialogIcon="display_settings"
                dialogTitle="Display Settings"
                showDialog={this.props.open}
                canResize={false}
                width={this.hasReports() ? 1000 : 800}
                zIndex={9997}>
                <DialogContent className="display-settings-dialog">
                    {this.props.workingDisplay && (
                        <Panel
                            flex={FlexDirection.Row}
                            overflow={Side.All}>
                            <GeneralContainer
                                flex={
                                    this.hasReports()
                                        ? FlexDirection.Row
                                        : FlexDirection.Column
                                }
                                bufferSide={Side.All}
                                overflow={Side.Vertical}
                                style={{ maxHeight: "70vh" }}>
                                {this.hasReports() ? (
                                    <>
                                        <GeneralContainer
                                            flexBehaviour={FlexBehaviour.Min}
                                            bufferSide={Side.Bottom}
                                            bufferSize={Size.XtraSmall}
                                            fitContent={true}>
                                            <Panel bufferSide={Side.All}>
                                                <DisplaySettingMain
                                                    routeDisplay={
                                                        this.props.routeDisplay
                                                    }
                                                    workingDisplay={
                                                        this.props
                                                            .workingDisplay
                                                    }
                                                />
                                            </Panel>
                                        </GeneralContainer>

                                        <DisplaySettingsReports
                                            workingDisplay={
                                                this.props.workingDisplay
                                            }
                                        />
                                    </>
                                ) : (
                                    <DisplaySettingMain
                                        routeDisplay={this.props.routeDisplay}
                                        workingDisplay={
                                            this.props.workingDisplay
                                        }
                                    />
                                )}
                            </GeneralContainer>
                        </Panel>
                    )}
                </DialogContent>
                <DialogFooter>
                    <DialogClose
                        onClick={() => this.props.displaySettingsClosed()}
                    />

                    <DialogOK
                        text="Save"
                        onClick={this.props.storeWorking}
                    />
                    <DialogOK
                        text="Save For All"
                        onClick={this.props.storeWorkingAll}
                    />
                </DialogFooter>
            </Dialog>
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    const { display } = state.db;
    return {
        routeDisplay: display.routeDisplay,
        workingDisplay: getWorkingConfig(),
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        initWorking: () => dispatch(initWorking()),
        storeWorking: () => dispatch(storeWorking()),
        storeWorkingAll: () => dispatch(storeWorkingAll()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DisplaySettings);
